import { useTranslation } from 'react-i18next';
import { gql, useMutation } from '@apollo/client';
import { showNotification, NOTIFICATION_TYPE } from '@thinknet-gmbh/platform-common-ui';

import { IHookCallbacks } from 'src/hooks/common.hooks.interfaces';

import { GET_PERMISSIONS_GROUPS } from './get-permissions-groups.hook';

export const CREATE_PERMISSIONS_GROUP = gql`
  mutation createPermissionsGroup($payload: CreatePermissionsGroupInput!) {
    createPermissionsGroup(payload: $payload) {
      _id
    }
  }
`;

export const useCreatePermissionsGroup = ({ onSuccess }: IHookCallbacks) => {
  const { t } = useTranslation('settings');

  const [createPermissionsGroup] = useMutation(CREATE_PERMISSIONS_GROUP, {
    onCompleted: () => {
      onSuccess();
      showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.success,
        message: t('permissionGroupSettings.notifications.permissionGroupAdded'),
      });
    },
    refetchQueries: [GET_PERMISSIONS_GROUPS],
  });

  return createPermissionsGroup;
};
